import React, { useMemo } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useQuery } from "@apollo/client/react";

import useAuth from "../../../hooks/useAuth";
import { CLIENTS_AND_PROJECTS_QUERY } from "../../../constants/graphql/queries";
import { getProjectsList } from "./index";
import ActionsModal from "./ActionsModal";
import AutoExpandEntitySelect from "./AutoExpandEntitySelect";
import {
  buildDuplicateProjectNameCounts,
  getProjectClientLabel,
  getProjectOptionLabel,
} from "../../../utils/projectOptionLabels";

export default function FilterProjectAndWarehouse({
  onSelectProject,
  projectId,
  md = 7,
  hideActions,
}) {
  const { user } = useAuth();
  const { settings } = user.company;
  const { data: { clients = [] } = {} } = useQuery(CLIENTS_AND_PROJECTS_QUERY, {
    fetchPolicy: "cache-first",
  });
  const projectList = getProjectsList(clients, "null", user);
  const duplicateNameCounts = useMemo(
    () => buildDuplicateProjectNameCounts(projectList),
    [projectList]
  );
  const showClientNameInProjectList = Boolean(settings.display_client_name_email_notification);

  const handleChangeProject = projectItem => {
    const nextProjectId = projectItem?.id;
    if (!nextProjectId) return;

    onSelectProject({
      clientId: "null",
      projectId: nextProjectId,
    });
  };

  return (
    <Grid container justify="space-between" alignItems="center" spacing={1}>
      <Grid size={{ xs: 12, md: md }}>
        <AutoExpandEntitySelect
          fullWidth
          allowEmpty
          name="project"
          label={settings.filter_field2}
          value={projectId}
          suggestions={projectList}
          onChange={handleChangeProject}
          getOptionLabel={option =>
            getProjectOptionLabel(option, duplicateNameCounts, showClientNameInProjectList)
          }
          renderOption={(props, option) => {
            const optionProps = { ...props };
            delete optionProps.key;
            const clientLabel = getProjectClientLabel(
              option,
              duplicateNameCounts,
              showClientNameInProjectList
            );
            return (
              <li {...optionProps} key={option.id}>
                {option.name}
                {clientLabel ? (
                  <Typography component="span" ml={0.5} color="text.secondary" fontSize={14}>
                    {" - "}
                    {clientLabel}
                  </Typography>
                ) : null}
              </li>
            );
          }}
          multiline
          maxRows={3}
        />
      </Grid>
      {!hideActions && (
        <Grid size={{ xs: 12, md: 5 }}>
          <ActionsModal />
        </Grid>
      )}
    </Grid>
  );
}
